module.exports = __webpack_public_path__ + "img/icon-partner.98ae2720.svg";